import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ReportBI } from '../../../../interfaces/reportes-bi.response.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TablerosBiService {
    private apiUrl: string = environment.apiSiriUrl;
    links: ReportBI[] = [];

    constructor(private http: HttpClient) {}

    GetBoards(): Observable<ReportBI[]> {
        return this.http.get<ReportBI[]>(`${this.apiUrl}reporte-admin`);
    }
}
